import React from 'react';
import { Link } from 'react-router-dom';

import bannerLogo from '../images/Jook_Web_White.png';

import PlayerCodeEntry from './PlayerCodeEntry';

import './NotFoundView.scss';

/**
 * Shown for any address the app does not have a screen for. Before this existed an
 * unmatched path rendered nothing at all, so a mistyped URL was a solid white page with
 * no error anywhere - indistinguishable from a broken deploy.
 *
 * The commonest way to get here is a mistyped player code, so the code box is on the
 * screen rather than a link back to the home screen to find it.
 */
const NotFoundView = () => (
  <div className="notfound">
    <div className="notfound-header">
      <img className="notfound-logo" src={bannerLogo} alt="Jookable" />
    </div>

    <div className="notfound-body">
      <div className="notfound-panel">
        <h1 className="notfound-title">We can't find that page</h1>
        <p className="notfound-message">
          That address does not exist. If you were adding songs to a player, enter the code shown on its screen and
          we will take you there.
        </p>

        <PlayerCodeEntry />

        <Link className="notfound-link" to="/home">
          Back to home
        </Link>
      </div>
    </div>
  </div>
);

export default NotFoundView;
